import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  cacheByView: null,
  fileBaseName: null,
};

const dashboardExportSlice = createSlice({
  name: "dashboardExport",
  initialState,
  reducers: {
    setExportContext(state, action) {
      state.cacheByView = action.payload.cacheByView;
      state.fileBaseName = action.payload.fileBaseName;
    },
    clearExportContext(state) {
      state.cacheByView = null;
      state.fileBaseName = null;
    },
  },
});

export const { setExportContext, clearExportContext } =
  dashboardExportSlice.actions;
export default dashboardExportSlice.reducer;
